import {
  AccountCircleRounded
} from "@mui/icons-material"
import { Box, Button, Card, CardContent, CardMedia, Container, IconButton, TextField, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import Navigation from "../components/navigation"
import { useEffect, useState } from "react"
import { socket } from ".."
import { deviceImage } from "../components/device"
import {
  styles,
  stylesDark,
  Styles,
  useTheme
} from "../providers/theme"
import { makeStyles } from "@mui/styles"
import useWidth from "../hooks/window"

const useStylesLight = makeStyles<any, Styles>({...styles})
const useStylesDark = makeStyles<any, Styles>({...stylesDark})

export default function Identify() {
  const navigate = useNavigate()
  const title = 'Identify'
  const [serialNumber, setSerialNumber] = useState<string>('')
  const [embosserCardData, setEmbosserCardData] = useState<any>(null)
  const [embosserManufacturedDate, setEmbosserManufacturedDate] = useState<string>('')
  const [embosserDeliveredDate, setEmbosserDeliveredDate] = useState<string>('')
  const {mode} = useTheme()
  const width = useWidth()
  let classesLight = useStylesLight(styles)
  let classesDark = useStylesDark(stylesDark)
  const classes = mode === 'light' ? classesLight : classesDark
  const months: any = {
    "01": "Jan",
    "02": "Feb",
    "03": "Mar",
    "04": "Apr",
    "05": "May",
    "06": "Jun",
    "07": "Jul",
    "08": "Aug",
    "09": "Sep",
    "10": "Oct",
    "11": "Nov",
    "12": "Dec"
  }

  const embosserIdentified = (data: any) => {
    if (data.error) {
      console.error(data.error)
    } else {
      setEmbosserCardData(data.embosserData)
      const manufacturedDate = data.embosserData !== null && data.embosserData !== undefined && data.embosserData.Manufactured ? data.embosserData.Manufactured.split('T').at(0).split('-') : ''
      const deliveredDate = data.embosserData !== null && data.embosserData !== undefined && data.embosserData.Delivered ? data.embosserData.Delivered.split('T').at(0).split('-') : ''
      setEmbosserManufacturedDate(`${manufacturedDate[2]} ${months[manufacturedDate[1]]} ${manufacturedDate[0]}`)
      setEmbosserDeliveredDate(`${deliveredDate[2]} ${months[deliveredDate[1]]} ${deliveredDate[0]}`)
    }
  }

  useEffect(() => {
    socket.on('embosser_identified', embosserIdentified)
    return () => {
      socket.off('embosser_identified', embosserIdentified)
    }
    // eslint-disable-next-line
  }, [])

  return (
    <Navigation
      title={title}
      actions={
        <>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="account-appbar"
            aria-haspopup="true"
            color="inherit"
            edge="end"
            onClick={() => navigate('/account')}
          >
            <AccountCircleRounded />
          </IconButton>
        </>
      }
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <Typography variant="h4" component="h1" my={2} sx={{ width: "100%", textAlign: "left", paddingInline: ".5em" }}>
            Identify your embosser
          </Typography>
          <Box
            sx={{
              width: "100%",
              marginTop: "1.5em",
              display: "flex",
              flexDirection: width < 900 ? "column" : "row"
            }}
          >
            <Box
              sx={{
                width: width < 900 ? "100%" : "50%",
                paddingInline: "1em"
              }}
            >
              <TextField
                sx={{
                  width: "100%",
                  marginBottom: "1.5em"
                }}
                defaultValue={serialNumber ?? ""}
                label="Serial Number"
                size="small"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setSerialNumber(event.target.value)
                }}
              />
              <Button
                sx={{
                  width: "100px",
                  maxWidth: "130px",
                  flexGrow: "1",
                  fontWeight: "bold",
                  color: "white",
                  backgroundColor: "#85d201",
                  margin: "0",
                  borderRadius: "10px",
                  paddingInline: ".5em",
                }}
                onClick={() => {
                  socket.emit('identify_embosser', serialNumber)
                }}
              >
                Search
              </Button>
            </Box>
            <Box
              sx={{
                width: width < 900 ? "100%" : "50%",
                paddingInline: "1em",
                marginTop: width < 900 ? "1.5em" : "0",
                display: "flex",
                alignItems: "flexStart",
                justifyContent: "center"
              }}
            >
              {
                embosserCardData !== null ?
                  <Card className={classes.embosserCard}>
                    <CardMedia
                      component="img"
                      height="200"
                      alt={embosserCardData.Model}
                      src={deviceImage(embosserCardData.Model)}
                      className={classes.embosserCardMedia}
                    />
                    <CardContent>
                      <PropertyArea
                        topMargin={true}
                        property={"Model"}
                        content={(embosserCardData.Model && embosserCardData.Model !== '') ? embosserCardData.Model : "Unknown"}
                        classes={classes}
                      />
                      <PropertyArea
                        topMargin={true}
                        property={"Serial"}
                        content={(embosserCardData.Serial_No && embosserCardData.Serial_No !== '') ? embosserCardData.Serial_No : "Unknown"}
                        classes={classes}
                      />
                      <PropertyArea
                        topMargin={true}
                        property={"Type"}
                        content={(embosserCardData.Type && embosserCardData.Type !== '') ? embosserCardData.Type : "Unknown"}
                        classes={classes}
                      />
                      <PropertyArea
                        topMargin={true}
                        property={"Company"}
                        content={(embosserCardData.Company && embosserCardData.Company !== '') ? embosserCardData.Company : "Unknown"}
                        classes={classes}
                      />
                      <PropertyArea
                        topMargin={true}
                        property={"Product ID"}
                        content={(embosserCardData.Item && embosserCardData.Item !== '') ? embosserCardData.Item : "Unknown"}
                        classes={classes}
                      />
                      <PropertyArea
                        topMargin={true}
                        property={"Manufactured"}
                        content={embosserManufacturedDate !== '' ? embosserManufacturedDate : "Unknown"}
                        classes={classes}
                      />
                      <PropertyArea
                        topMargin={true}
                        property={"Delivered"}
                        content={embosserDeliveredDate !== '' ? embosserDeliveredDate : "Unknown"}
                        classes={classes}
                      />
                    </CardContent>
                  </Card>
                :
                  <p
                    style={{
                      fontSize: "1.75em"
                    }}
                  >
                    No result
                  </p>
              }
            </Box>
          </Box>
        </Box>
      </Container>
    </Navigation>
  )
}

function PropertyArea({
  property,
  content,
  topMargin,
  classes
}: {
  property: string,
  content: string,
  topMargin?: boolean,
  classes: any
}) {
  return (
    <div 
      className={`
        ${classes.propertyArea}
        ${topMargin && classes.propertyAreaTopMargin}
      `}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          alignItems: "flex-start"
        }}
      >
        <p className={classes.propertyAreaProperty}>
          {property}
        </p>
        <p className={classes.propertyAreaContent}>
          {content}
        </p>
      </div>
    </div>
  )
}